import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SupplierUserModel } from 'src/common';
import { HttpClient } from '@angular/common/http';



const localApiUrl = `${environment.apiUrl}/SupplierUser`;

@Injectable()
export class SupplierUserService {

  constructor(private http: HttpClient) { }

  getById(id: number): Promise<SupplierUserModel> {
    return this.http.get<SupplierUserModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}



